import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f69ae1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "v-pagination-per-page" }
const _hoisted_2 = {
  key: 0,
  class: "prev-next"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Prev ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_5 = ["textContent"]
const _hoisted_6 = {
  key: 0,
  class: "limit"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "limit-text" }, "Items Per Page", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_form_select_option = _resolveComponent("b-form-select-option")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_row = _resolveComponent("b-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_row, { "align-content": "center" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          lg: "4",
          md: "4"
        }, {
          default: _withCtx(() => [
            (_ctx.pagination.total > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["prev", { 'prev--disabled': _ctx.disabledPrev }]),
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPrevClick && _ctx.onPrevClick(...args))),
                    onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPrevClick && _ctx.onPrevClick(...args)))
                  }, [
                    _createVNode(_component_fa, {
                      icon: "chevron-circle-left",
                      style: {"width":"16px","height":"auto"}
                    }),
                    _hoisted_3
                  ], 34),
                  _createElementVNode("span", {
                    class: _normalizeClass(["next", { 'next--disabled': _ctx.disabledNext }]),
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onNextClick && _ctx.onNextClick(...args))),
                    onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onNextClick && _ctx.onNextClick(...args)))
                  }, [
                    _hoisted_4,
                    _createVNode(_component_fa, {
                      icon: "chevron-circle-right",
                      style: {"width":"16px","height":"auto"}
                    })
                  ], 34)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, {
          lg: "4",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "total",
              textContent: _toDisplayString(_ctx.totalText)
            }, null, 8, _hoisted_5)
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, {
          lg: "4",
          md: "4"
        }, {
          default: _withCtx(() => [
            (_ctx.pagination.perPage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_b_form_select, {
                    name: "limit",
                    size: "md",
                    items: _ctx.limitOptions,
                    disabled: _ctx.disabledLimit,
                    onChange: _ctx.onLimitSelect,
                    value: _ctx.pagination.perPage,
                    class: "limit-select"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limitOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_b_form_select_option, {
                          value: item.value,
                          key: item.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.text), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["items", "disabled", "onChange", "value"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}